import { defineStore } from 'pinia';

import { catchError } from '@/helpers/toast';
import {
  fetchFixture,
  fetchInProgressFixtures,
  finishFixture,
  postMarketResolution,
  resetMarket,
} from '@/api/admin-be';

// @ts-ignore file is not in project deps
import type { ResultSet } from '../../../../libs/bet-genius/src/common/result-set/result-set.types';

export type InProgressFixture = {
  id: number;
  name: string;
  start_time_utc: string;
  event_status_type: string;

  results_count: number;
  open_bets_count: number;

  sport_id: number;
  sport_name: string;

  competition_id: number;
  competition_name: string;
};

export const useFixturesStore = defineStore('fixtures', {
  state: () => ({
    inProgressFixturesLoading: false,
    inProgressFixtures: null as null | InProgressFixture[],
    inProgressFixturesCount: 0,
    inProgressFixturesOffset: 0,
    inProgressFixturesPageSize: 15,
  }),
  actions: {
    async fetchInProgressFixtures(filters?: any) {
      this.inProgressFixturesLoading = true;

      const paginatedFilters = {
        ...filters,
        offset: this.inProgressFixturesOffset,
        count: this.inProgressFixturesPageSize,
      };

      return fetchInProgressFixtures(paginatedFilters)
        .then((result) => {
          const page = Math.floor(this.inProgressFixturesOffset / this.inProgressFixturesPageSize);
          const maxPage = Math.floor(result.count / this.inProgressFixturesPageSize);

          if (page > maxPage) {
            this.inProgressFixturesOffset = 0;
            this.fetchInProgressFixtures(filters);
            return;
          }

          this.inProgressFixtures = result.fixtures;
          this.inProgressFixturesCount = result.count;
        })
        .catch((error) => catchError('Ошибка загрузки live-матчей', error))
        .finally(() => (this.inProgressFixturesLoading = false));
    },
    async finishFixture(fixture: InProgressFixture) {
      return finishFixture(fixture.id).catch((error) =>
        catchError('Ошибка завершения матча', error)
      );
    },
    async fetchFixtureDirect(id: number) {
      return fetchFixture(id).catch((error) => catchError('Ошибка загрузки матча', error));
    },
    async resetMarket(marketId: number) {
      return resetMarket(marketId).catch((error) => catchError('Ошибка сброса маркета', error));
    },
    async finalizeMarket(market: any, fixtureId: number) {
      const firstSelection = market[Object.keys(market)[0]];
      const marketId = firstSelection?.MarketId;

      const data: ResultSet = {
        Results: [
          {
            Results: Object.keys(market).map((id) => ({
              SelectionId: parseInt(id),
              ResultStatus: market[id].ResultStatus,
              AdditionalResultData: market[id].AdditionalResultData || undefined,
            })),
            MarketId: marketId,
            MarketSequence: 1,
          },
        ],
        FixtureId: fixtureId,
      };

      const result = await postMarketResolution(data)
        .then((res) => {
          catchError(`Маркет ${marketId}`, { message: 'Результат успешно отправлен' }, 'success');

          return res;
        })
        .catch((error) => catchError('Ошибка закрытия маркета', error));

      return !!result;
    },
  },
});
